import Input from "@components/Input";
import { Row } from "@components/Layout";
import type { TTSBlock } from "@components/TTSEditor/types";
import { Show, type VoidComponent, createMemo } from "solid-js";
import type { SetStoreFunction } from "solid-js/store";
import { z } from "zod";
import type { TTSLanguage } from "../ModeSelect/types";
import { getVoice } from "../ModeSelect/utils";
import Preview from "../Preview";
import { PreviewWrapper } from "../Preview/styled";
import VoiceSwitcher from "./components/VoiceSwitcher";
import { InputWrapper } from "./styled";

const SimpleMode: VoidComponent<{
	setTTSBlocks: SetStoreFunction<TTSBlock[]>;
	blocks: TTSBlock[];
	language: TTSLanguage;
	maxLimit: number;
	minLimit: number;
}> = (props) => {
	const femaleVoice = createMemo(() => getVoice(props.language, "female"));
	const maleVoice = createMemo(() => getVoice(props.language, "male"));

	return (
		<>
			<Show when={props.blocks[0]} keyed>
				{(block) => (
					<>
						<InputWrapper>
							<Input
								value={block.text}
								textArea
								onChange={(v) => props.setTTSBlocks(0, "text", v)}
								max={props.maxLimit}
								parseResult={z.string().min(props.minLimit).max(props.maxLimit).safeParse(block.text)}
							/>
							<PreviewWrapper>
								<Preview blocks={props.blocks} />
							</PreviewWrapper>
						</InputWrapper>
						<Row justifyContent="space-between" gap="10px" padding="10px 0 0">
							<VoiceSwitcher
								active={block.voice === femaleVoice().code}
								name={femaleVoice().name}
								onClick={() => {
									props.setTTSBlocks(0, "voice", femaleVoice().code);
									props.setTTSBlocks(0, "languageCode", femaleVoice().languageCode);
								}}
								photo={femaleVoice().photo}
								source={femaleVoice().sample}
								voice_code={femaleVoice().code}
							/>
							<VoiceSwitcher
								active={block.voice === maleVoice().code}
								name={maleVoice().name}
								onClick={() => {
									props.setTTSBlocks(0, "voice", maleVoice().code);
									props.setTTSBlocks(0, "languageCode", maleVoice().languageCode);
								}}
								photo={maleVoice().photo}
								source={maleVoice().sample}
								voice_code={maleVoice().code}
							/>
						</Row>
					</>
				)}
			</Show>
		</>
	);
};
export default SimpleMode;
